import Vue from 'vue';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import {
  faAdd,
  faAddressBook,
  faArrowLeftLong,
  faArrowRightLong,
  faBan,
  faBell,
  faCalendarCheck,
  faCalendarXmark,
  faCaretDown,
  faCheck,
  faCircleCheck,
  faCircleInfo,
  faCirclePlus,
  faCircleXmark,
  faCopy,
  faCreditCardAlt,
  faCube,
  faDollarSign,
  faDownload,
  faEnvelope,
  faExternalLink,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileLines,
  faFilePdf,
  faGaugeHigh,
  faGlobe,
  faHardDrive,
  faHouse,
  faImage,
  faLanguage,
  faLightbulb,
  faLock,
  faMagnifyingGlass,
  faMoneyCheckDollar,
  faPaperPlane,
  faPencil,
  faPhone,
  faPhotoFilm,
  faQrcode,
  faReceipt,
  faRefresh,
  faTrash,
  faUser,
  faX,
} from '@fortawesome/free-solid-svg-icons';

/* add icons to the library */
library.add(
  faAdd,
  faAddressBook,
  faArrowLeftLong,
  faArrowRightLong,
  faBan,
  faBell,
  faCalendarCheck,
  faCalendarXmark,
  faCaretDown,
  faCheck,
  faCircleCheck,
  faCircleInfo,
  faCirclePlus,
  faCircleXmark,
  faCopy,
  faCreditCardAlt,
  faCube,
  faDollarSign,
  faDownload,
  faEnvelope,
  faExternalLink,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileLines,
  faFilePdf,
  faGaugeHigh,
  faGlobe,
  faHardDrive,
  faHouse,
  faImage,
  faLanguage,
  faLightbulb,
  faLock,
  faMagnifyingGlass,
  faMoneyCheckDollar,
  faPaperPlane,
  faPencil,
  faPhone,
  faPhotoFilm,
  faQrcode,
  faReceipt,
  faRefresh,
  faTrash,
  faUser,
  faX,
);

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon);
